export const UnitOfMeasureValidation = (formData) => {
    const errors = {};
  
    // Validate each field
    if (!formData.Measurment.trim()) {
      errors.Measurment = 'Measurment is required';
    } 
   
    return errors;
  };
  
 